import React from 'react';
import { connect } from 'react-redux';
import { Card, CardContent, CardMedia, Grid } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { MEDIA_RESOURCE_TYPE, MEDIA_SOURCE_TYPE, MEDIA_USAGE_TYPE } from '../../../../CreatePageConstants';
import { mediaPickerActions } from '../../../store';
import { createActions } from '../../../../store';
import { createMediaSourceDataForImage, createMediaSource, createMediaSourceDataForVideo } from '../../../../helpers';
import AppConstants from '../../../../../../../App/AppConstants';
import ProMediaCardLabel from '../../../common/ProMediaCardLabel';

const styles = theme => ({
    assetCard: {
        margin: theme.spacing(0.5),
        cursor: 'pointer'
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0
        }
    },
    assetCardMedia: {
        '& h6': {
            display: 'none'
        },
        '&:hover': {
            '& h6': {
                display: 'block'
            }
        }
    }
});

const UserAssetsCard = (props) => {
    const { 
        classes, userAsset, galleryCardWidth, galleryCardHeight, mediaUsageType, setMediaPickersProperty, 
        updateVisualizerSettings, updateBackgroundSettings, setProperty, subscriptionType, openPremiumVideosDialog,
        savingInProgress, showCriticalOperationProgressWarning, isVideoExportsQueued, onAssetSelect
    } = props;

    const professionalVideoAsset = (userAsset.mediaResourceType === MEDIA_RESOURCE_TYPE.VIDEO && subscriptionType === AppConstants.FREE_SUBSCRIPTION_TYPE);

    const onAssetClick = () => {
        if (savingInProgress) {
            showCriticalOperationProgressWarning();
            return;
        }

        if (isVideoExportsQueued())
            return;

        // Pickers that are not bound to a single media usage type handle the selection themselves.
        if (onAssetSelect) {
            onAssetSelect(userAsset);
            return;
        }

        switch(mediaUsageType) {
            case MEDIA_USAGE_TYPE.LOGO: {
                const mediaData = createMediaSourceDataForImage(userAsset.originalUrl);
                const mediaSource = createMediaSource(mediaData, MEDIA_SOURCE_TYPE.USER_ASSET, userAsset.id, MEDIA_RESOURCE_TYPE.IMAGE);
                updateVisualizerSettings({ mediaSource: mediaSource, logoVisible: true });
                setProperty('logoMediaPickerOpen', false);
                break;
            }
            case MEDIA_USAGE_TYPE.BACKGROUND: {
                switch(userAsset.mediaResourceType) {
                    case MEDIA_RESOURCE_TYPE.IMAGE: {
                        const mediaData = createMediaSourceDataForImage(userAsset.originalUrl);
                        const mediaSource = createMediaSource(mediaData, MEDIA_SOURCE_TYPE.USER_ASSET, userAsset.id, MEDIA_RESOURCE_TYPE.IMAGE);
                        updateBackgroundSettings({ mediaSource: mediaSource });
                        break;
                    }
                    case MEDIA_RESOURCE_TYPE.VIDEO: {
                        if (professionalVideoAsset) {
                            setMediaPickersProperty('backgroundMediaPickerOpen', false);
                            openPremiumVideosDialog(userAsset.url, () => {
                                setMediaPickersProperty('backgroundMediaPickerOpen', true);
                            }, 'user`s video assets');
                        } else {
                            const mediaData = createMediaSourceDataForVideo(userAsset.url, userAsset.url, userAsset.url, userAsset.url);
                            const mediaSource = createMediaSource(mediaData, MEDIA_SOURCE_TYPE.USER_ASSET, userAsset.id, MEDIA_RESOURCE_TYPE.VIDEO);
                            updateBackgroundSettings({ mediaSource: mediaSource });
                        }
                        break;
                    }
                }
                setProperty('backgroundMediaPickerOpen', false);
                break;
            }
        }
    };  

    return (
        <Grid>
            <Card 
                className={classes.assetCard}
                style={{width: galleryCardWidth}}
                onClick={onAssetClick}
            >
                <CardContent className={classes.cardContent}>
                    {professionalVideoAsset && <ProMediaCardLabel width={135} />}

                    <CardMedia
                        className={classes.assetCardMedia}
                        style={{height: galleryCardHeight}}
                        crossOrigin='anonymous'
                        component={(userAsset.mediaResourceType === MEDIA_RESOURCE_TYPE.IMAGE) ? 'img' : 'video'}
                        src={(userAsset.mediaResourceType === MEDIA_RESOURCE_TYPE.IMAGE) ? userAsset.thumbnailUrl : userAsset.url}
                    />
                </CardContent>
            </Card>
        </Grid>
    );
}

const mapStateToProps = (state, ownProps) => {
    const { subscriptionType } = state.app.accountDetails;
    const { savingInProgress } = state.create.videoSavingState;

    return { 
        subscriptionType,
        savingInProgress 
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const isVideoExportsQueued = () => dispatch(createActions.isVideoExportsQueued());
    const setMediaPickersProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    const openPremiumVideosDialog = (videoUrl, onGoBack, location) => dispatch(mediaPickerActions.openPremiumVideosDialog(videoUrl, onGoBack, location));
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return { 
        setProperty,
        isVideoExportsQueued,
        setMediaPickersProperty,
        updateVisualizerSettings,
        updateBackgroundSettings,
        openPremiumVideosDialog,
        showCriticalOperationProgressWarning
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(UserAssetsCard, styles));